import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../loader/Loader";
import { useCreateAdminInviteMutation } from "../../features/api/subscriptionApiSlice";

const AdminInvite = () => {
  const navigate = useNavigate();
  const [createInvite, { isLoading }] = useCreateAdminInviteMutation();

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    role: Yup.string()
      .oneOf(["Admin", "Owner"], "Invalid role")
      .required("Role is required"),
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const res = await createInvite(values).unwrap();
      toast.success(res?.message || "Admin invite sent successfully!");
      resetForm();
      navigate("/admin/invite"); // or stay on page if you prefer
    } catch (error) {
      toast.error(error?.data?.message || "Failed to send admin invite.");
    } finally {
      setSubmitting(false);
    }
  };

  if (isLoading) return <LoadingSpinner />;

  return (
    <div className="dashboard-wrapper">
      <div className="dashboard-top-section">
        <div className="dash-top-flex">
          <h1 className="dashboard-title">Invite Admin</h1>
        </div>
      </div>

      <Formik
        initialValues={{
          email: "",
          role: "Admin",
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form className="dashboard-form">
            {/* Email */}
            <div>
              <label htmlFor="email">
                Email Address<span className="required-field">*</span>
              </label>
              <Field
                type="email"
                name="email"
                placeholder="admin@example.com"
              />
              <ErrorMessage name="email" component="div" className="error" />
            </div>

            {/* Role */}
            <div className="form-controls">
              <label htmlFor="role">
                Role<span className="required-field">*</span>
              </label>
              <Field as="select" name="role">
                <option value="Admin">Admin</option>
                <option value="Owner">Owner</option>
              </Field>
              <ErrorMessage name="role" component="div" className="error" />
            </div>

            {/* Submit */}
            <button
              type="submit"
              disabled={isSubmitting}
              className="form-button"
            >
              Send Admin Invite
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AdminInvite;
